import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialDomainHunterPage() {
    const navigate = useNavigate();
    const [domain, setDomain] = useState('');
    const [status, setStatus] = useState('idle'); // idle, checking, available, taken

    const checkDomain = (e) => {
        e.preventDefault();
        if (!domain) return;
        setStatus('checking');

        // Simulation
        setTimeout(() => {
            if (Math.random() > 0.3) setStatus('available');
            else setStatus('taken');
        }, 1500);
    };

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#1e293b', color: 'white', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

            <div style={{ width: '100%', maxWidth: 700, textAlign: 'center' }}>
                <h1 style={{ fontSize: '3rem', fontWeight: 800, marginBottom: 10 }}>🎯 Domain Hunter</h1>
                <p style={{ opacity: 0.6, fontSize: '1.2rem', marginBottom: 40 }}>Sécurisez votre territoire digital avant les autres.</p>

                <form onSubmit={checkDomain} style={{ width: '100%', position: 'relative' }}>
                    <input
                        autoFocus
                        type="text" placeholder="votre-marque.com"
                        value={domain} onChange={e => { setDomain(e.target.value.toLowerCase()); setStatus('idle'); }}
                        style={{
                            width: '100%', padding: '25px', paddingRight: 80, borderRadius: 50, border: 'none',
                            fontSize: '1.5rem', background: 'white', color: 'black', fontWeight: 700, boxShadow: '0 20px 50px rgba(0,0,0,0.3)', outline: 'none'
                        }}
                    />
                    <div style={{ position: 'absolute', right: 25, top: '50%', transform: 'translateY(-50%)', fontSize: '1.5rem' }}>
                        {status === 'checking' ? '...' : '🔍'}
                    </div>
                </form>

                <div style={{ minHeight: 200, marginTop: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {status === 'checking' && <div className="spinner" />}

                    {status === 'available' && (
                        <div className="animate-pop" style={{ background: '#22c55e', padding: 40, borderRadius: 24, width: '100%' }}>
                            <div style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 5 }}>FÉLICITATIONS !</div>
                            <div style={{ fontSize: '2.5rem', fontWeight: 900 }}>{domain} est LIBRE ✅</div>
                            <p style={{ margin: '20px 0', opacity: 0.9 }}>Ne laissez pas un concurrent le prendre.</p>
                            <button style={{ padding: '15px 40px', background: 'white', color: '#166534', border: 'none', borderRadius: 50, fontSize: '1.2rem', fontWeight: 800, cursor: 'pointer' }}>RÉSERVER MAINTENANT</button>
                        </div>
                    )}

                    {status === 'taken' && (
                        <div className="animate-shake" style={{ background: '#ef4444', padding: 40, borderRadius: 24, width: '100%' }}>
                            <div style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 5 }}>DOMMAGE...</div>
                            <div style={{ fontSize: '2.5rem', fontWeight: 900 }}>{domain} est PRIS ❌</div>
                            <p style={{ margin: '20px 0', opacity: 0.9 }}>Essayez avec un tiret ou une autre extension (.fr, .io)</p>
                            <button onClick={() => { setDomain(''); setStatus('idle'); }} style={{ padding: '15px 40px', background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', borderRadius: 50, fontSize: '1.2rem', fontWeight: 700, cursor: 'pointer' }}>Nouvelle Recherche</button>
                        </div>
                    )}
                </div>

                <button onClick={() => navigate('/commercial/launchpad')} style={{ marginTop: 50, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.3)', cursor: 'pointer' }}>Retour</button>
            </div>

            <style>{`
                .spinner { width: 40px; height: 40px; border: 4px solid rgba(255,255,255,0.3); border-top-color: white; border-radius: 50%; animation: spin 1s linear infinite; }
                @keyframes spin { to { transform: rotate(360deg); } }
                .animate-pop { animation: popIn 0.5s ease-out; }
                @keyframes popIn { from { transform: scale(0.8); opacity: 0; } to { transform: scale(1); opacity: 1; } }
                .animate-shake { animation: shake 0.5s ease-in-out; }
                @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-10px); } 75% { transform: translateX(10px); } }
            `}</style>
        </div>
    );
}
